export default __webpack_public_path__ + "static/media/02.d4e9b96b.jpg";